import PropTypes from 'prop-types';
import React from 'react';
import ReactMapboxGl, { Layer, Feature, Marker as MapboxMarker, ZoomControl } from 'react-mapbox-gl';

import { MAPBOX_STYLE } from 'app/common/constants';

const POLYGON_COLOR = '#0094c9';

const Mapbox = props => {
    const Map = ReactMapboxGl({
        accessToken: props.token,
        scrollZoom: false,
    });

    return (
        <div className="detail-map-container" style={{ position: 'relative' }}>
            <Map
                style={MAPBOX_STYLE}
                center={props.center}
                containerStyle={{
                    height: '100%',
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    backgroundColor: 'rgb(229, 227, 223)',
                }}
                zoom={[props.zoom - 1]}
            >
                {props.hasNeighborhoodPaths && (
                    <Layer
                        type="fill"
                        paint={{
                            'fill-color': POLYGON_COLOR,
                            'fill-outline-color': POLYGON_COLOR,
                            'fill-opacity': 0.25,
                        }}
                    >
                        <Feature coordinates={props.neighborhoodGeometry} />
                    </Layer>
                )}
                {props.showCircle && (
                    <Layer
                        type="circle"
                        paint={{
                            'circle-radius': {
                                base: 2,
                                stops: [[0, 0], [20, 5400]],
                            },
                            'circle-color': POLYGON_COLOR,
                            'circle-opacity': 0.25,
                        }}
                    >
                        <Feature coordinates={props.center} />
                    </Layer>
                )}
                {props.showMarker && (
                    <MapboxMarker coordinates={props.center}>
                        <div
                            style={{
                                backgroundColor: '#e74c3c',
                                borderRadius: '50%',
                                width: 20,
                                height: 20,
                                border: '4px solid #EAA29B',
                            }}
                        />
                    </MapboxMarker>
                )}
                <ZoomControl />
            </Map>
        </div>
    );
};

Mapbox.propTypes = {
    token: PropTypes.string,
    showCircle: PropTypes.bool,
    showMarker: PropTypes.bool.isRequired,
    center: PropTypes.array,
    hasNeighborhoodPaths: PropTypes.bool,
    neighborhoodGeometry: PropTypes.array,
    zoom: PropTypes.number,
};

export default Mapbox;
